/**
 * Module chuẩn hóa và phân đoạn văn bản (Text Normalizer & Segmenter)
 * Tuân thủ chuẩn GDD Mục 9 & 10:
 * - Chuẩn hóa ký tự trắng, khoảng cách, loại bỏ ký tự điều khiển.
 * - Phân đoạn thành từng câu ngắn gọn để đọc trôi chảy, không gây nghẽn buffer.
 */
export class TextSegmenterService {
  /**
   * Chuẩn hóa văn bản trước khi xử lý
   * @param {string} text
   * @returns {string}
   */
  static normalizeText(text) {
    if (!text || typeof text !== 'string') return '';

    return text
      // Chuẩn hóa khoảng trắng lặp thừa
      .replace(/\s+/g, ' ')
      // Chuẩn hóa dấu ngoặc kép và dấu chấm câu
      .replace(/[""]/g, '"')
      .replace(/['']/g, "'")
      // Xóa các ký tự điều khiển vô hình
      .replace(/[\u0000-\u001F\u007F-\u009F]/g, '')
      .trim();
  }

  /**
   * Phân đoạn danh sách đoạn văn (paragraphs) thành các segment câu đọc
   * @param {string[]} paragraphs Danh sách các đoạn văn
   * @returns {Array<{ id: string, order: number, text: string, paragraphIndex: number }>}
   */
  static segmentParagraphs(paragraphs) {
    if (!Array.isArray(paragraphs)) return [];

    const segments = [];
    let orderIndex = 0;

    paragraphs.forEach((rawPara, pIdx) => {
      const cleanPara = this.normalizeText(rawPara);
      if (!cleanPara) return;

      // Tách đoạn văn thành các câu theo dấu chấm, chấm than, hỏi chấm hoặc dấu hai chấm
      // Sử dụng regex lookbehind/lookahead an toàn để không làm mất dấu câu
      const rawSentences = cleanPara.split(/(?<=[.!?…])\s+/);

      rawSentences.forEach((sentence) => {
        const cleanSentence = sentence.trim();
        if (cleanSentence.length > 0) {
          segments.push({
            id: `seg-${orderIndex}`,
            order: orderIndex,
            text: cleanSentence,
            paragraphIndex: pIdx,
          });
          orderIndex++;
        }
      });
    });

    return segments;
  }
}
